import { Component, OnDestroy, OnInit } from '@angular/core';
import { LoginInfoService } from 'src/app/services/login-info/login-info.service';
import { Subscription } from 'rxjs';
//import { SharedService } from 'src/app/shared/services/shared-service/shared.service';

@Component({
  selector: 'wpro-contact',
  templateUrl: './contact.component.html',
  styleUrls: ['./contact.component.scss'],
  standalone: false
})
export class ContactComponent implements  OnDestroy {
  lockEditContactFlag: boolean;
  private subscriptions = new Subscription();

  constructor(
    public loginService: LoginInfoService
   // public sharedService: SharedService
  ) {}

  // ngOnInit(): void {
  //  // this.getUserInfo();
  // }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }

  

  // getUserInfo(): void {
  //   this.subscriptions.add(
  //     this.loginService.getLoginInfo().subscribe(
  //       (response) => {
  //           if (response.output.userProfile.profileLocked) {
  //             this.lockEditContactFlag = true;
  //           } else {
  //             this.lockEditContactFlag = false;
  //           }
  //       },
  //       (httpError) => {}
  //     )
  //   );
  // }
  // editButtonclick(): any {
  //   this.sharedService.isEditLinkClicked = true;
  // }
}
